import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import { __assign, __values } from "tslib";

var OrderDetailData =
/** @class */
function () {
  function OrderDetailData(detail) {
    this.is_after_sale = false;
    this.choices_o = detail.choices;
    this.choices = detail.choices.filter(function (ele) {
      var _a;

      return (((_a = ele.left_count) !== null && _a !== void 0 ? _a : 999) || (ele.left_count === 0 && ele.id === +detail.specification ? 1 : 0)) > 0;
    });
    this.id = detail.id;
    this.activity_id = detail.activity_id;
    this.name = detail.name;
    this.gender = detail.gender;
    this.mobile = detail.mobile;
    this.district_1 = detail.district_1;
    this.district_2 = detail.district_2;
    this.district_3 = detail.district_3;
    this.district = [detail.district_1, detail.district_2, detail.district_3].filter(function (_) {
      return _;
    });
    this.address = detail.address;
    this.status = detail.status;
    this.type = detail.type;
    this.express_company = detail.express_company;
    this.express_number = detail.express_number;
    this.express_detail = detail.express_detail;
    this.can_change_before = detail.can_change_before;
    this.can_change = detail.can_change;
    this.gift = detail.gift;
    this.specification = +detail.specification;
  }

  Object.defineProperty(OrderDetailData.prototype, "giftInfo", {
    get: function get() {
      return __assign(__assign({}, this.gift), {
        choices: this.choices,
        specification: this.specification
      });
    },
    enumerable: false,
    configurable: true
  });

  OrderDetailData.prototype.getSpec = function () {
    var e_1, _a, e_2, _b;

    if (!this.specification) {
      return '';
    }

    try {
      for (var _c = __values(this.choices), _d = _c.next(); !_d.done; _d = _c.next()) {
        var choice = _d.value;

        if (choice.id === this.specification) {
          return [this.gift.spec_1 ? this.gift.spec_1 + ':' : null, choice.spec_1, this.gift.spec_2 ? this.gift.spec_2 + ':' : null, choice.spec_2, this.gift.spec_3 ? this.gift.spec_3 + ':' : null, choice.spec_3].filter(function (_) {
            return _;
          }).join(' ');
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c["return"])) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    try {
      for (var _e = __values(this.choices_o), _f = _e.next(); !_f.done; _f = _e.next()) {
        var choice = _f.value;

        if (choice.id === this.specification) {
          return [this.gift.spec_1 ? this.gift.spec_1 + ':' : null, choice.spec_1, this.gift.spec_2 ? this.gift.spec_2 + ':' : null, choice.spec_2, this.gift.spec_3 ? this.gift.spec_3 + ':' : null, choice.spec_3].filter(function (_) {
            return _;
          }).join(' ');
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e["return"])) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return '';
  };

  OrderDetailData.prototype.canModify = function () {// let canModify = isUndef(this.can_change_address) ? false : this.can_change_address;
    // if (this && this.gifts) {
    //     this.gifts.forEach((gift: EquipmentGift) => {
    //         if (gift.can_change === true) {
    //             canModify = true;
    //         }
    //     });
    // }
    // return canModify;
  };

  return OrderDetailData;
}();

export default OrderDetailData;